import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

import type { RootState } from '../reducer'
import type { AppDispatch } from './configure'

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
